import React, { ReactElement, Component, useContext, useState, useEffect, useMemo, useCallback } from "react";
import { Link } from 'react-router-dom';
import { injectIntl, FormattedMessage } from 'react-intl';
import './user-management.less';
import { Row, Col, Button, Input, Table, Tag, Form, Select, Radio, Modal, Dropdown, Menu, Spin, Tooltip } from 'antd';
import { ColumnProps } from 'antd/es/table';
import { user, UserContext } from "../../contexts/user-management";
import { UserInfoContext } from '../../contexts/user-info';
import { USER_URL, formatDate, isEffective, guid, parse_option_data, parse_w_option_data } from './user-util';
import { worker_fetch } from "../../worker/worker-fetch";
import { EditOutlined, MoreOutlined, FilterOutlined, PlusOutlined, QuestionCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { DatacenternameContext } from "../../contexts/datacenter-name";
// @ts-ignore
import { useDebounce } from "use-lodash-debounce";
import { useDeepCompareMemo } from 'use-deep-compare';

// interface pagination_config_type {
//     total?: number;
// }

const default_reg = /^(?!All).*/,
    ACTIVE = 'Active',
    DISABLED = 'Disabled',
    DISABLE = 'disable',
    ENABLE = 'enable';

export const UserManagement = injectIntl((props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
    const user_info = useContext(UserInfoContext)[0],
        datacenter_name: string | undefined = useContext(DatacenternameContext)[0],
        // clusters: clusters_type_item[] = useContext(ClusterContext)[0],
        [userlist, set_userlist]: [user[], React.Dispatch<React.SetStateAction<any>>] = useContext(UserContext),
        [dropdown_visible, set_dropdown_visible]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false),
        [is_spin, set_is_spin]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false),
        [disable_user_modal_visible, set_disable_user_modal_visible] = useState(false),
        [triggle_reload, set_triggle_reload] = useState(false), // 仅仅是用来触发更新 user list，无实际意义
        [disable_user_word, set_disable_user_word] = useState(''),
        [disable_action, set_disable_action] = useState(''),
        // [selected_row, set_selected_row]: [any[], React.Dispatch<React.SetStateAction<any[]>>] = useState<any[]>([]),
        [will_disable_row, set_will_disable_row]: [any[], React.Dispatch<React.SetStateAction<any[]>>] = useState<any[]>([]),
        // [selected_row_key, set_selected_row_key] = useState([]),

        // 请求头部的筛选信息(datacenter cluster workspace namespace)
        [cluster_item, set_cluster_item] = useState([]),
        [cluster_select, set_cluster_select] = useState([]),
        [workspace_item, set_workspace_item] = useState([]),
        [workspace_select, set_workspace_select] = useState([]),
        [namespace_item, set_namespace_item] = useState([]),
        [namespace_select, set_namespace_select] = useState([]),
        [search_value, set_search_value]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(''),

        [form] = Form.useForm(),
        { setFieldsValue, getFieldsValue } = useMemo(() => form, [form]),

        all_option_modal = (value: string) => {
            return { id: guid(), name: value };
        },
        all_option_modal_2 = (value: string) => {
            return { id: value, name: value };
        },

        { history } = useMemo(() => props, [props]),
        { formatMessage }: { formatMessage: any } = useDeepCompareMemo(() => props.intl, [props.intl]),
        search_value_final = useDebounce(search_value, 500),

        parseSelect = useCallback((data: any) => Array.isArray(data) ? data.map((item: any) => {
            const { key, value, text } = item;

            return key ?
                <Select.Option value={value === formatMessage({ id: 'select_cluster' }) || value === formatMessage({ id: 'select_ws' }) || value === formatMessage({ id: 'select_ns' }) ? '' : value} key={key} >
                    {` ${text}`}
                </Select.Option>
                :
                undefined;
        }) : [], [formatMessage]),

        state = history.location.state,

        // 将各种筛选条件带入edit页面再带回
        { f_ct, f_ws, f_ns, p_n, f_s, w_f_s, f_n } = useMemo(() => {
            if (state && state.src === 'edit') {
                delete state.src;
                return state;
            } else return { f_ct: '', f_ws: '', f_ns: '', p_n: 1, f_s: '', w_f_s: '', f_n: '', s_d: '', s_p: '' };
        }, [state]),

        // 分页及筛选
        [page_number, set_page_number]: [number, React.Dispatch<React.SetStateAction<number>>] = useState(p_n),
        // [pagination_config, set_pagination_config]: [pagination_config_type | undefined, React.Dispatch<React.SetStateAction<pagination_config_type | undefined>>] = useState<pagination_config_type | undefined>(),
        [filter_status, set_filter_status] = useState(f_s),
        [will_filter_status, set_will_filter_status] = useState(w_f_s),
        [filter_name, set_filter_name] = useState(f_n),
        [filter_cluster, set_filter_cluster] = useState(f_ct),
        [filter_workspace, set_filter_workspace] = useState(f_ws),
        [filter_namespace, set_filter_namespace] = useState(f_ns),

        handle_cluster_change = useCallback((value: any) => {
            sessionStorage.removeItem('workspace_user');
            sessionStorage.removeItem('namespace_user');
            if (default_reg.test(value)) {
                set_filter_cluster(value);
                !value ? sessionStorage.removeItem('cluster_user') : sessionStorage.setItem('cluster_user', value);
                !value && setFieldsValue({ clsuter: formatMessage({ id: 'select_cluster' }) });
            } else {
                // set_filter_cluster('');
                set_workspace_item([]);
                set_namespace_item([]);
            }
            set_workspace_item([]);
            set_namespace_item([]);
            setFieldsValue({ workspace: formatMessage({ id: 'select_ws' }), namespace: formatMessage({ id: 'select_ns' }) });
            set_filter_workspace('');
            set_filter_namespace('');
            set_page_number(1);
        }, [setFieldsValue, formatMessage]),

        handle_workspace_change = useCallback((value: any) => {
            sessionStorage.removeItem('namespace_user');
            if (value !== '') {
                set_filter_workspace(value);
                sessionStorage.setItem('workspace_user', value);
            } else {
                set_filter_workspace('');
                set_namespace_item([]);
                sessionStorage.removeItem('workspace_user');
            }
            set_namespace_item([]);
            set_filter_namespace('');
            setFieldsValue({ namespace: formatMessage({ id: 'select_ns' }) });
            set_page_number(1);
        }, [setFieldsValue, formatMessage]),

        handle_namespace_change = useCallback((value: any) => {
            set_filter_namespace(value);
            value !== '' ? sessionStorage.setItem('namespace_user', value) : sessionStorage.removeItem('namespace_user');
            set_page_number(1);
        }, []),

        handle_disable_user = useCallback(async () => {
            if (will_disable_row.length > 0 && datacenter_name) {
                await Promise.all(will_disable_row.map(async ({ username, status }: { username: string, status: string }) => {
                    ((disable_action === DISABLE && status === ACTIVE) || (disable_action === ENABLE && status === DISABLED)) &&
                        await worker_fetch({ url: `/v1/mpusers/${username}?cockroach=true`, method: 3, props: { formatMessage, history }, datacenter_name });
                }))
                set_triggle_reload(!triggle_reload);
                // set_selected_row_key([]);
                set_disable_user_modal_visible(false);
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [disable_action, history, triggle_reload, will_disable_row, datacenter_name]),

        handle_click_disable_user = useCallback((record: any, action: string) => {
            if (user_info.id === record.id) {
                return;
            }
            set_disable_user_modal_visible(true);
            set_will_disable_row([record]);
            set_disable_action(action);
            if (action === DISABLE) {
                set_disable_user_word(formatMessage({ id: 'disable_user' }));
            } else {
                set_disable_user_word(formatMessage({ id: 'enable_user' }));
            }
        }, [formatMessage, user_info.id]),

        // show_batch_modal = useCallback((action: string) => {
        //     set_disable_user_modal_visible(true);
        //     set_will_disable_row(selected_row);
        //     set_disable_action(action);
        //     if (action === DISABLE) {
        //         set_disable_user_word(formatMessage({ id: 'disable_users' }));
        //     } else {
        //         set_disable_user_word(formatMessage({ id: 'enable_users' }));
        //     }
        // }, [set_disable_user_modal_visible, set_will_disable_row, set_disable_action, set_disable_user_word, formatMessage, selected_row]),

        // rowSelection = useMemo(() => ({
        //     selectedRowKeys: selected_row_key,
        //     onChange: (selectedRowKeys: any, selectedRows: any) => {
        //         set_selected_row(selectedRows);
        //         set_selected_row_key(selectedRowKeys);
        //     }
        // }), [selected_row_key]),

        // batch_operation_menu = useMemo(() =>
        //     <Menu>
        //         <Menu.Item key="0">
        //             <div className="pointer hover p-6">
        //                 <div className="font-9 text-left p-6" onClick={() => { show_batch_modal(DISABLE) }}> <FormattedMessage id='disable'></FormattedMessage> </div>
        //             </div>
        //         </Menu.Item>
        //         <Menu.Item key="1">
        //             <div className="pointer hover p-6">
        //                 <div className="font-9 text-left p-6" onClick={() => { show_batch_modal(ENABLE) }}> <FormattedMessage id='enable'></FormattedMessage> </div>
        //             </div>
        //         </Menu.Item>
        //     </Menu>, [show_batch_modal]),

        columns: ColumnProps<user>[] = useMemo(() => [
            {
                title: formatMessage({ id: 'name' }),
                dataIndex: 'username',
                sorter: (a: any, b: any) => a && b && a?.username?.localeCompare(b.username),
                render:(name: any) => (
                    <div className="font-w-7">{name}</div>
                )
            },
            {
                title: formatMessage({ id: 'highest_role' }),
                dataIndex: 'role',
                sorter: (a: any, b: any) => a && b && a.role.localeCompare(b.role)
            },
            {
                title: formatMessage({ id: 'status' }),
                dataIndex: 'status',
                sorter: (a: any, b: any) => a && b && a.status.localeCompare(b.status),
                filterDropdown: () => (
                    <div style={{ padding: 8 }}>
                        <Row style={{ marginBottom: '10px' }}>
                            <Radio.Group onChange={(e) => { set_will_filter_status(e.target.value) }} value={will_filter_status || filter_status}>
                                <Radio className='radio-search active-status' value='Active'>
                                    <FormattedMessage id='active'></FormattedMessage>
                                </Radio>
                                <Radio className='radio-search disabled-status' value='Disabled'>
                                    <FormattedMessage id='disabled'></FormattedMessage>
                                </Radio>
                            </Radio.Group>
                        </Row>
                        <Button
                            type="primary"
                            onClick={() => { filter_status !== will_filter_status && set_filter_status(will_filter_status); }}
                            size="small"
                            style={{ width: 90, marginRight: 8 }}
                        >
                            <FormattedMessage id='search'></FormattedMessage>
                        </Button>
                        <Button
                            onClick={() => { set_filter_status(''); set_will_filter_status(''); }}
                            size="small" style={{ width: 90 }}>
                            <FormattedMessage id='reset'></FormattedMessage>
                        </Button>
                    </div>
                ),
                filterIcon: () => (
                    <FilterOutlined style={{ color: filter_status ? '#1890ff' : undefined }} />
                ),
                onFilterDropdownVisibleChange: (visible: any) => {
                    if (!visible) {
                        set_will_filter_status('');
                    }
                },
                render: (status: any) => (
                    status ? <Tag color={status.toLowerCase() === 'active' ? '#2bc41ab5' : 'lightgray'}><span className="tag_status">{status}</span></Tag> : status
                )
            },
            {
                title: formatMessage({ id: 'last_login' }),
                dataIndex: 'lastSignedInTime',
                sorter: (a: any, b: any) => {
                    let a_time = new Date(a.lastSignedInTime).getTime();
                    let b_time = new Date(b.lastSignedInTime).getTime();
                    return a_time - b_time;
                },
                render: (login: any) => formatDate(login) || formatMessage({ id: 'not_login' }),
            },
            {
                title: formatMessage({ id: 'operation' }),
                dataIndex: 'operate',
                width: 200,
                align: 'center',
                render: (_text: string, record: any) => (
                    <Dropdown overlay={dropdown_visible ? (
                        <Menu className="small_dropdown setting-dropdown">
                            <Menu.Item key={`${record.userId}1`}>
                                <div className="pointer hover p-6">
                                    <Link to={{
                                        pathname: USER_URL.editProfile, state: {
                                            src: 'edit',
                                            username: record.username,
                                            status: {
                                                f_ct: filter_cluster,
                                                f_ws: filter_workspace,
                                                f_ns: filter_namespace,
                                                f_ur: getFieldsValue().usersrole,
                                                p_n: page_number,
                                                f_s: filter_status,
                                                w_f_s: will_filter_status,
                                                f_n: filter_name,
                                            }
                                        }
                                    }}>
                                        <div className="pointer hover p-6 normal-color">
                                            <EditOutlined /> <FormattedMessage id='edit'></FormattedMessage>
                                        </div>
                                    </Link>
                                </div>
                            </Menu.Item>
                            {/* {!!user_info.is_globaladmin && (<Menu.Item key={`${record.userId}2`} disabled={user_info.id === record.id} >
                                <div className="pointer hover p-6">
                                    <div className="font-9 text-left p-6" onClick={showDeleteOneModal.bind(null, record)}>
                                        <DeleteOutlined /> <FormattedMessage id='delete'></FormattedMessage>
                                    </div>
                                </div>
                            </Menu.Item>)} */}
                            {/* {!!user_info.is_globaladmin && <Menu.Item key={`${record.userId}3`} disabled={user_info.id === record.id}>
                                <div className="pointer hover p-6" onClick={() => { handle_click_disable_user(record, ACTIVE === record.status ? DISABLE : ENABLE) }}>
                                    <div className="font-9 text-left p-6" > <ToolOutlined />&nbsp;
                                        {ACTIVE === record.status ? (<FormattedMessage id='disable'></FormattedMessage>) : <FormattedMessage id='enable'></FormattedMessage>}
                                    </div>
                                </div>
                            </Menu.Item>} */}
                        </Menu>
                    ) : <div></div>
                    } trigger={['click']} placement="bottomCenter">
                        <Button className="plain_button" onClick={() => { set_dropdown_visible(true) }}>
                            <MoreOutlined />
                        </Button>
                    </Dropdown>
                )
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        ], [dropdown_visible, filter_cluster, filter_name, filter_namespace, filter_status, filter_workspace, getFieldsValue,
            handle_click_disable_user, formatMessage, user_info.is_globaladmin, user_info.id, page_number,
            will_filter_status]),

        search_part: JSX.Element[] = useMemo((): JSX.Element[] =>
            [
                <Col sm={12} key="dropdowns">
                    <Row gutter={10}>
                        <Col sm={8}>
                            <Form.Item name='cluster' >
                                <Select
                                    size='large'
                                    showSearch
                                    placeholder={formatMessage({ id: 'select_cluster' })}
                                    optionFilterProp="children"
                                    onChange={handle_cluster_change}
                                >
                                    {parseSelect(cluster_select)}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col sm={8}>
                            <Form.Item name='workspace'>
                                <Select
                                    size='large'
                                    showSearch
                                    placeholder={formatMessage({ id: 'select_ws' })}
                                    optionFilterProp="children"
                                    onChange={handle_workspace_change}
                                >
                                    {parseSelect(workspace_select)}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col sm={8}>
                            <Form.Item name='namespace'>
                                <Select
                                    size='large'
                                    showSearch
                                    placeholder={formatMessage({ id: 'select_ns' })}
                                    optionFilterProp="children"
                                    onChange={handle_namespace_change}
                                >
                                    {parseSelect(namespace_select)}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                </Col>,
                <Col sm={12} key="search_create">
                    <Row gutter={10}>
                        <Col sm={user_info.is_namespacedeveloper ? 24 : 22} key="input">
                            <Form.Item>
                                <Input
                                    style={{marginTop: "5px"}}
                                    size="large"
                                    // enterButton
                                    allowClear
                                    prefix={<SearchOutlined />}
                                    onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
                                    if (event.keyCode === 13) event.preventDefault();
                                    }}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => { set_search_value(e.target.value) }}
                                    placeholder={`${formatMessage({ id: 'please_input_ ' })}${formatMessage({ id: 'username' })}`}
                                />
                            </Form.Item>
                        </Col>
                        <Col sm={user_info.is_namespacedeveloper ? 0 : 2} className="text-right">
                            <Form.Item>
                                <Link to={{
                                    pathname: USER_URL.editProfile, state: {
                                        src: 'add', status: {
                                            f_ct: filter_cluster,
                                            f_ws: filter_workspace,
                                            f_ns: filter_namespace,
                                            f_ur: getFieldsValue().usersrole,
                                            p_n: page_number,
                                            f_s: filter_status,
                                            w_f_s: will_filter_status,
                                            f_n: filter_name,
                                        }
                                    }
                                }} >
                                    <Button className="plain_button create_button" type="primary">
                                        <PlusOutlined />
                                    </Button>
                                </Link>
                            </Form.Item>
                        </Col>
                    </Row>
                </Col>
            ], [formatMessage, handle_cluster_change, parseSelect, cluster_select, handle_workspace_change, workspace_select, handle_namespace_change, namespace_select, user_info.is_namespacedeveloper, filter_cluster, filter_workspace, filter_namespace, getFieldsValue, page_number, filter_status, will_filter_status, filter_name]);

    // 下拉选筛选开始
    // useEffect(() => {
    //     worker_fetch({ url: `/v1/datacenternames`, func: set_data_center_item, props: { formatMessage, history }, datacenter_name });
    // }, [set_data_center_item, history, datacenter_name]);

    // useEffect(() => {
    //     if (Array.isArray(data_center_item)) {
    //         if (data_center_item.length === 1) {
    //             const default_dc = data_center_item[0].name;
    //             setFieldsValue({ 'dataCenter': default_dc });
    //             set_filter_data_center(default_dc);
    //         }
    //         set_data_center_select(parse_option_data([all_option_modal(ALL_DATACENTER), ...data_center_item]));
    //     }

    // }, [data_center_item, setFieldsValue]);

    // useEffect(() => {
    //     if (isEffective(filter_data_center)) {
    //         worker_fetch({ url: `/v1/datacenter/${filter_data_center}/clusternames`, func: set_cluster_item, props: { formatmessage, history }, warning: false , datacenter_name});
    //     }
    // }, [set_cluster_item, filter_data_center, history]);

    useEffect((): void => {
        set_filter_name(search_value_final);
        set_page_number(1);
    }, [search_value_final])

    // 获取cluster的可选项
    useEffect(() => {
        if (datacenter_name && user_info.userName) {
            worker_fetch({ url: `/v1/datacenter/${datacenter_name}/clusternames`, func: set_cluster_item, props: { history, formatMessage, warning: false }, datacenter_name });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [set_cluster_item, datacenter_name, history, user_info.userName]);

    useEffect((): void => {
        cluster_item.length && set_cluster_select(parse_option_data([all_option_modal_2(formatMessage({ id: 'select_cluster' })), ...cluster_item]))
        // clusters.length && set_cluster_select(parse_option_data(clusters.map((cluster: clusters_type_item): clusters_type_item['metadata'] => cluster.metadata)));
    }, [cluster_item, setFieldsValue, formatMessage]);

    useEffect((): void => {
        const cluster_selected_name: string | undefined = sessionStorage.getItem('cluster_user') || undefined;
        setFieldsValue({ cluster: cluster_selected_name || formatMessage({ id: 'select_cluster' }) });
        cluster_selected_name && set_filter_cluster(cluster_selected_name);
        const workspace_selected: { name: string, id: string } | undefined =
            (workspace_item.find(({ id }: any) => id === sessionStorage.getItem('workspace_user')) as { name: string, id: string } | undefined);

        workspace_selected && set_filter_workspace(workspace_selected.id);
        setFieldsValue({ workspace: workspace_selected?.name || formatMessage({ id: 'select_ws' }) });
        const namespace_selected_name: string | undefined =
            (namespace_item.find(({ id }: any) => id === sessionStorage.getItem('namespace_user')) as { name: string, id: string } | undefined)?.name;
        namespace_selected_name && set_filter_namespace(namespace_selected_name);
        setFieldsValue({ namespace: namespace_selected_name || formatMessage({ id: 'select_ns' }) });
    }, [setFieldsValue, cluster_item, formatMessage, namespace_item, workspace_item]);

    useEffect((): void => {
        Array.isArray(workspace_item) && set_workspace_select(parse_w_option_data([all_option_modal_2(formatMessage({ id: 'select_ws' })), ...workspace_item]));
    }, [workspace_item, formatMessage]);

    useEffect(() => {
        isEffective(filter_cluster) && datacenter_name &&
            worker_fetch({ url: `/v1/datacenter/${datacenter_name}/cluster/${filter_cluster}/workspacenames`, func: set_workspace_item, props: { formatMessage, history }, warning: false, datacenter_name });
            // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [datacenter_name, filter_cluster, set_workspace_item, history]);

    useEffect(() => {
        // set_filter_namespace('');
        Array.isArray(namespace_item) && set_namespace_select(parse_option_data([all_option_modal(formatMessage({ id: 'select_ns' })), ...namespace_item]));
    }, [namespace_item, formatMessage]);

    useEffect(() => {
        isEffective(filter_cluster) && isEffective(filter_workspace) && datacenter_name &&
            worker_fetch({ url: `/v1/datacenter/${datacenter_name}/cluster/${filter_cluster}/workspace/${filter_workspace}/namespacenames`, func: set_namespace_item, props: { formatMessage, history }, warning: false, datacenter_name });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [datacenter_name, filter_cluster, filter_workspace, set_namespace_item, history]);
    // 下拉选筛选结束

    // 使用名称筛选时不走这里，测试要求筛选完显示第一页
    // useEffect(() => {
    //     if (datacenter_name) {
    //         (async () => {
    //             const { usersrole } = getFieldsValue(),
    //                 status_search = isEffective(filter_status) ? `&status=${filter_status}` : '',
    //                 name_search = isEffective(filter_name) ? `&userName=${filter_name}` : '',
    //                 usersrole_search = isEffective(usersrole) ? `&role=${parse_to_kebab(usersrole)}` : '',
    //                 //  data_center_search = isEffective(filter_data_center) ? `&datacenter=${filter_data_center}` : '';
    //                 cluster_search = isEffective(filter_cluster) ? `&cluster=${filter_cluster}` : '',
    //                 workspace_search = isEffective(filter_workspace) ? `&workspace=${filter_workspace}` : '',
    //                 namespace_search = isEffective(filter_namespace) ? `&namespace=${filter_namespace}` : '',
    //                 // direction = isEffective(sort_direction) ? `&direction=${sort_direction}` : '',
    //                 // property = isEffective(sort_property) ? `&orderBy=${sort_property}` : '',
    //                 users = (user_info.is_globaladmin || user_info.is_datacenteradmin || cluster_search) && page_number && (await worker_fetch({
    //                     url: `/v1/users/info?pageNumber=${page_number}&pageSize=10${status_search}${name_search}${usersrole_search}&datacenter=${datacenter_name}${cluster_search}${workspace_search}${namespace_search}&direction=ascend&orderBy=username`,
    //                     props: { formatMessage, history },
    //                     datacenter_name
    //                 }) as any).data;

    //             if (users) {
    //                 if (Array.isArray(users.items)) {
    //                     set_userlist(users.items.map((item: any) => ({
    //                         key: item.id,
    //                         id: item.id,
    //                         username: item.username,
    //                         role: item.role,
    //                         status: item.status,
    //                         lastSignedInTime: item.lastSignedInTime,
    //                     })));
    //                 }
    //                 set_pagination_config({ total: users.totalCount });
    //             }
    //         })();
    //     }
    // }, [page_number, filter_status, filter_name, filter_cluster, filter_workspace, filter_namespace,
    //     triggle_reload, formatMessage, history, getFieldsValue, datacenter_name, set_userlist, user_info.is_datacenteradmin, user_info.is_globaladmin]);

    useEffect(() => {
        if (datacenter_name && user_info.userName) {
            (async () => {
                const cluster_search = isEffective(filter_cluster) || sessionStorage.getItem('cluster_user')  ? `&cluster=${filter_cluster || sessionStorage.getItem('cluster_user')}` : '',
                    workspace_search = isEffective(filter_workspace) || sessionStorage.getItem('workspace_user') ? `&workspace=${filter_workspace || sessionStorage.getItem('workspace_user')}` : '',
                    namespace_search = isEffective(filter_namespace) || sessionStorage.getItem('namespace_user') ? `&namespace=${filter_namespace || sessionStorage.getItem('namespace_user')}` : '',
                    // users = (await worker_fetch({
                    //     url: `/v1/users/info?pageNumber=1&pageSize=100&datacenter=${datacenter_name}${cluster_search}${workspace_search}${namespace_search}&direction=ascend&orderBy=username`,
                    //     props: { formatMessage, history },
                    //     datacenter_name
                    // }) as any).data;
                    get_total: number = (await worker_fetch({
                        url: `/v1/users/info?pageNumber=1&pageSize=1&datacenter=${datacenter_name}${cluster_search}${workspace_search}${namespace_search}&direction=ascend&orderBy=username`,
                        props: { formatMessage, history },
                        datacenter_name
                    }) as any).data?.totalCount;
                const users: any = { items: [], totalCount: 0 },
                    userlist = [];
                get_total === 0 && set_is_spin(false);
                if (Math.ceil(get_total / 100) > 0) {
                    set_is_spin(true);
                    for (let i = 1; i <= Math.ceil(get_total / 100); i++) {
                        const list = (await worker_fetch({
                            url: `/v1/users/info?pageNumber=${i}&pageSize=100&datacenter=${datacenter_name}${cluster_search}${workspace_search}${namespace_search}&direction=ascend&orderBy=username`,
                            props: { formatMessage, history },
                            datacenter_name
                        }) as any).data?.items;
                        list && userlist.push(...list);
                    }
                    users.items = userlist;
                    // users.items.push(...userlist);
                    users.totalCount = userlist.length;
                }
                if (users) {
                    set_is_spin(false);
                    if (Array.isArray(users.items)) {
                        set_userlist(users.items
                            .filter((each: any) => each.status.toLocaleLowerCase() !== 'delete')
                            .map((item: any, index: number) => ({
                            key: index.toString() + item.userId,
                            id: item.userId,
                            username: item.username,
                            role: item.role,
                            status: item.status,
                            lastSignedInTime: item.lastSignedInTime,
                        })));
                    }
                }
            })();
        }
         // eslint-disable-next-line
    }, [filter_cluster, filter_workspace, filter_namespace, datacenter_name, set_userlist, set_is_spin, user_info.userName, history]);

    return (
        <div className='user-mgmt px-20 mt-20'>
            <Row>
                <Col sm={24} className="card_title management-label-line font-size-16">
                    <FormattedMessage id='resource_permissions' />
                    <Tooltip placement="rightBottom" title={<FormattedMessage id='resource_permissions_sub' />}><QuestionCircleOutlined className="autoscale_help" /></Tooltip>
                </Col>
                <div className="management-select-area w-100">
                    {/* <Col sm={24} className="no_color small_font card_title_desc header-title-sub"><FormattedMessage id='resource_permissions_sub' /></Col> */}
                    <Col sm={24}>
                        <Form form={form}>
                            <Row gutter={10} className='mt-10 select-group input_no_border'>
                                {user_info && user_info.role && search_part}
                                {/* {user_info && user_info.role && user_info.role !== 'namespaceDeveloper' && <Col sm={2}>
                                    <Row className="text-right">
                                        <Col span={24}>
                                            <Form.Item>
                                                <Link to={{
                                                    pathname: USER_URL.editProfile, state: {
                                                        src: 'add', status: {
                                                            f_ct: filter_cluster,
                                                            f_ws: filter_workspace,
                                                            f_ns: filter_namespace,
                                                            f_ur: getFieldsValue().usersrole,
                                                            p_n: page_number,
                                                            f_s: filter_status,
                                                            w_f_s: will_filter_status,
                                                            f_n: filter_name,
                                                            w_f_n: will_filter_name,
                                                        }
                                                    }
                                                }} >
                                                    <Button className="plain_button create_button">
                                                        <PlusOutlined />
                                                    </Button>
                                                </Link>
                                            </Form.Item>
                                        </Col> */}
                                {/* <Col span={8}>
                                    <Button className="plain_button" disabled={selected_row.length === 0} onClick={handle_delete_user}>
                                        <Icon type="delete" />
                                    </Button>
                                </Col> */}
                                {/* <Col span={12}>
                                            {!!user_info.is_globaladmin && <Dropdown className='small_dropdown' overlay={batch_operation_menu} trigger={['click']} disabled={selected_row.length === 0}>
                                                <Button className="plain_button p-0">
                                                    <SettingOutlined />
                                                </Button>
                                            </Dropdown>}
                                        </Col> */}
                                {/* </Row> */}
                                {/* </Col>} */}
                            </Row>
                        </Form>
                    </Col>
                </div>
            </Row>
            <Spin spinning={is_spin} tip="Loading..." size="large">
                <Row className="management-table w-100 no_pointer mt-20">
                    <Table size="small" className="ant-col-sm-24" columns={columns} dataSource={userlist.filter((item: any) => ((item?.username || "").toLocaleLowerCase()).includes(search_value.toLocaleLowerCase().trim()))} rowClassName={() => 'font-w-7'}
                        onChange={(pagination: any) => { set_page_number(pagination.current) }}
                        pagination={{ pageSize: 10, current: page_number, showSizeChanger: false }} showSorterTooltip={false}
                    />
                </Row>
            </Spin>
            {/* <Modal
                title={formatMessage({ id: 'confirm' })}
                visible={delete_modal_visible}
                onOk={() => { delete_user_request() }}
                onCancel={() => { set_delete_modal_visible(false) }}
            >
                <p>{delete_user_word}</p>
            </Modal> */}
            <Modal
                title={formatMessage({ id: 'confirm' })}
                visible={disable_user_modal_visible}
                onOk={handle_disable_user}
                onCancel={() => { set_disable_user_modal_visible(false) }}
            >
                <p>{disable_user_word}</p>
            </Modal>
        </div>
    )
});

// export const UserManagement = Form.create({})(UserManagementModel);